<template>
  <vs-card>
    <header @click="toggleCart" slot="header">
      <span>&euro; {{ total_price }}</span>
    </header>

    <div>
      <cart-item
        v-for="(product, index) in cart"
        :key="product.uuid"
        :product_id="product.id"
        :product_uuid="product.uuid"
        :name="product.name"
        :quantity="product.quantity"
        :price="product.price"
        :sale_price="product.sale_price"
        :addons="product.addons"
        :note="product.note"
        :last="cart.length - 1 == index ? true : false"
      ></cart-item>
      <discount-item
        v-for="discount in cartDiscounts"
        :key="discount.discountName + '' + discount.name"
        :name="discount.name"
        :discount="discount.discount"
        :discountName="discount.discountName"
      ></discount-item>
    </div>
    <vs-list class="cart-footer" v-if="cart.length > 0">
      <vs-list-item>
        <span slot="title">Subtotaal:</span>
        <span slot="subtitle" class="is-pulled-right">&euro; {{ subtotal_price }}</span>
      </vs-list-item>
      <vs-list-item v-if="delivery_fee > 0">
        <span slot="title">Bezorgkosten:</span>
        <span slot="subtitle" class="is-pulled-right">&euro; {{ delivery_fee }}</span>
      </vs-list-item>
      <vs-list-item v-if="discount > 0">
        <span slot="title">Korting:</span>
        <span slot="subtitle" class="is-pulled-right">&euro; {{ discount }}</span>
      </vs-list-item>
      <vs-list-item>
        <strong slot="title">Totaal:</strong>
        <strong slot="subtitle" class="is-pulled-right">&euro; {{ total_price }}</strong>
      </vs-list-item>
    </vs-list>
  </vs-card>
</template>

<script>
import CartItem from "./CartItem.vue";
import DiscountItem from "./DiscountItem.vue";

export default {
  mounted() {
    if (localStorage.getItem("cart-" + this.company_slug)) {
      this.cart = JSON.parse(localStorage.getItem("cart-" + this.company_slug));
    }
    this.$events.listen("productPushedToCart", this.getProducts);
    this.$events.listen("decreasedCartItemQty", this.updateProductsMinus);
    this.$events.listen("increasedCartItemQty", this.updateProductsPlus);
    this.$events.listen("removeItem", this.removeItem);
    this.$events.listen("postcode", this.getPostcodeFromEvent);
    this.$events.listen("option", event => (this.option = event));
    this.$events.listen("couponApplied", event => this.couponDiscount = event)
    this.applyDiscountToCart();
  },
  components: {
    "cart-item": CartItem,
    "discount-item": DiscountItem
  },
  props: [
    "company_name",
    "company_slug",
    "company_status",
    "delivery_fees",
    "delivery_fee",
    "discounts",
    "postcode"
  ],
  data() {
    return {
      cart: [],
      cartDiscounts: [],
      open: false,
      close: false,
      noCheckout: false,
      option: "",
      couponDiscount: 0,
      weekdays: [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday"
      ]
    };
  },
  watch: {
    company_name: function() {
      if (localStorage.getItem("cart-" + this.company_slug)) {
        this.cart = JSON.parse(localStorage.getItem("cart-" + this.company_slug));
      } else {
        this.cart = [];
      }
    },
    total_quantity: function() {
      this.setCartToCookie();
      this.$events.fire("total_price", this.total_price);
    },
    checkout: function() {
      if (this.checkout === true) {
        this.$events.fire("checkout", this.checkout);
      } else {
        this.$events.fire("checkout-false");
      }
    }
  },
  computed: {
    discount: function() {
      var total = 0;
      this.cartDiscounts.map(cartDiscount => {
        total = total + cartDiscount.discount;
      });
      return total + this.couponDiscount;
    },
    total_price: function() {
      if (this.delivery_fee === undefined) {
        return this.subtotal_price - this.discount;
      } else {
        return (this.delivery_fee + (this.subtotal_price - this.discount) );
      }
    },
    total_quantity: function() {
      var quantity = 0;
      for (let i in this.cart) {
        quantity += this.cart[i].quantity;
      }

      return quantity;
    },
    subtotal_price: function() {
      let price = 0;
      this.cart.map((item) => {
        let productPrice = item.price;
        if(item.addons !== undefined) {
          if(item.addons.length > 0) {
            item.addons.map(addon => {
              if(addon.price !== null) {
                productPrice += Number(addon.price)
              }
            })
          }
        }
        price += productPrice * item.quantity;
      })
      return price;
    },
    neededOrderAmount: function() {
      return this.minimum_order_amount - (this.subtotal_price - this.discount);
    },
    itemsInCart: function() {
      if (this.cart.length > 0) {
        return true;
      }
      return false;
    },
    minimum_order_amount: function() {
      for (let i in this.delivery_fees) {
        if (this.postcode == null) {
          return Number(0);
        } else if (this.delivery_fees[i].location.postal_code.includes(this.postcode)) {
          return Number(this.delivery_fees[i].minimum_order_amount);
        }
      }
    },
    checkoutUrl: function() {
      if(this.noCheckout) {
        return '#'
      } else {
        return { name: "restaurant-afrekenen", params: { restaurant: this.company_slug } };
      }
    },
  },
  methods: {
    getPostcodeFromEvent: function(event) {
      this.postcode = event;
    },
    getDeliveryFees: function() {
      this.$http.get()
        .then(response => {
          this.delivery_fees = response.data;
        })
        .catch(error => {
          this.delivery_fees_errors = error;
        });
    },
    toggleCart: function() {
      if (this.open === false) {
        this.open = true;
        this.close = false;
      } else {
        this.open = false;
        this.close = true;
      }
    },
    openCart: function() {
      this.open = true;
    },
    closeCart: function() {
      this.open = false;
    },
    getProducts: function(event) {
      for (let i in this.cart) {
        if (this.cart[i].id === event.id) {
          if (this.cart[i].addons.length > 0) {
            if (this.cart[i].uuid !== event.uuid) {
              this.applyDiscount(event, "increase");
              this.cart.push(event);
              this.notifyUser("added_product", event);
              return;
            }
          }
          if(this.cart[i].note !== event.note) {
            this.applyDiscount(event, "increase");
            this.cart.push(event);
            this.notifyUser("added_product", event);
            return;
          }

          this.cart[i].quantity += event.quantity;
          this.cart[i].total_price = this.cart[i].total_price + event.total_price;
          this.applyDiscount(this.cart[i], "increase");
          this.notifyUser("added_product", this.cart[i]);
          return;
        }
      }

      this.cart.push(event);
      this.applyDiscount(event, "increase");
      this.notifyUser("added_product", event);
    },
    applyDiscountToCart: function() {
      for (let i in this.cart) {
        this.applyDiscount(this.cart[i], "increase");
      }
    },
    checkIfDiscountIsApplied: function(product) {
      var count = 0;
      if (_.isEmpty(this.cartDiscounts)) {
        return false;
      } else {
        this.cartDiscounts.map((cartDiscount, i) => {
          if (
            cartDiscount.id == product.id ||
            cartDiscount.id == product.product_id
          ) {
            count = count + 1;
          }
        });
        if (count > 1) {
          return true;
        }
      }
    },
    applyDiscount: function(event, type) {
      this.discounts.map(discount => {
        if (discount.type == "PRICE") {
          this.handlePriceDiscount(event, discount, type);
        } else if (discount.type == "PERCENTAGE") {
          this.handlePercentageDiscount(event, discount, type);
        }
      });
    },
    handlePriceDiscount: function(item, discount, type) {
      if (!_.isEmpty(discount.products)) {
        discount.products.map(product => {
          if (item.product_id === product.id || item.id === product.id) {
            this.applyPriceDiscount(item, discount, type);
          }
        });
      } else if (!_.isEmpty(discount.categories)) {
        discount.categories.map(category => {
          if (item.cat_id === category.id) {
            this.applyPriceDiscount(item, discount, type);
          }
        });
      } else {
        this.applyPriceDiscount(item, discount, type);
      }
    },
    applyPriceDiscount: function(item, discount, type) {
      JSON.parse(discount.days_available).map(day => {
        let today = new Date();

        if (day === this.weekdays[today.getDay()]) {
          let applyDiscount = 0;
          let total = 0;
          switch (type) {
            case "increase":
              applyDiscount = Number(item.price - discount.amount).toFixed(2);
              this.setDiscount("increase", item, applyDiscount, discount.name);
              break;
            case "decrease":
              applyDiscount = Number(item.price - discount.amount).toFixed(2);
              this.setDiscount("decrease", item, applyDiscount, discount.name);
              break;
            case "remove":
              total = item.price * item.quantity;
              applyDiscount = Number(
                total - discount.amount * item.quantity
              ).toFixed(2);
              this.setDiscount("remove", item, applyDiscount, discount.name);
              break;
            default:
              total = item.price * item.quantity;
              applyDiscount = Number(
                total - discount.amount * item.quantity
              ).toFixed(2);
              this.setDiscount(type, item, applyDiscount, discount.name);
              break;
          }
        }
      });
    },
    handlePercentageDiscount: function(item, discount, type) {
      if (!_.isEmpty(discount.products.data)) {
        discount.products.data.map(product => {
          if (item.product_id === product.id || item.id === product.id) {
            this.applyPercentageDiscount(item, discount, type);
          }
        });
      } else if (!_.isEmpty(discount.categories.data)) {
        discount.categories.data.map(category => {
          if (item.cat_id === category.id) {
            this.applyPercentageDiscount(item, discount, type);
          }
        });
      } else {
        this.applyPercentageDiscount(item, discount, type);
      }
    },
    applyPercentageDiscount: function(item, discount, type) {
      JSON.parse(discount.days_available).map(day => {
        let today = new Date();

        if (day === this.weekdays[today.getDay()]) {
          let applyDiscount = 0;
          let total = 0;
          switch (type) {
            case "increase":
              applyDiscount = Number(
                (item.price / 100) * discount.amount
              ).toFixed(2);
              this.setDiscount("increase", item, applyDiscount, discount.name);
              break;
            case "decrease":
              applyDiscount = Number(
                (item.price / 100) * discount.amount
              ).toFixed(2);
              this.setDiscount("decrease", item, applyDiscount, discount.name);
              break;
            case "remove":
              total = item.price * item.quantity;
              applyDiscount = Number((total / 100) * discount.amount).toFixed(
                2
              );
              this.setDiscount("remove", item, applyDiscount, discount.name);
              break;
            default:
              total = item.price * item.quantity;
              applyDiscount = Number((total / 100) * discount.amount).toFixed(
                2
              );
              this.setDiscount(type, item, applyDiscount, discount.name);
              break;
          }
        }
      });
    },
    setDiscount: function(type, item, discount, discountName) {
      var discountItem = {
        cat_id: item.cat_id,
        id: item.id,
        name: item.name,
        quantity: item.quantity,
        uuid: item.uuid,
        discount: item.quantity * Number(discount),
        discountName: discountName
      };
      switch (type) {
        case "increase":
          for (let i in this.cartDiscounts) {
            if (this.cartDiscounts[i].uuid == item.uuid) {
              if (this.cartDiscounts[i].discountName == discountName) {
                this.cartDiscounts[i].quantity =
                  this.cartDiscounts[i].quantity + 1;
                this.cartDiscounts[i].discount =
                  item.quantity * Number(discount);
                return;
              }
            }
          }

          this.cartDiscounts.push(discountItem);
          break;
        case "decrease":
          for (let i in this.cartDiscounts) {
            if (this.cartDiscounts[i].uuid === item.uuid) {
              if (this.cartDiscounts[i].quantity == 1) {
                this.cartDiscounts.splice(i, 1);
                return;
              }
              this.cartDiscounts[i].quantity =
                this.cartDiscounts[i].quantity - 1;
              this.cartDiscounts[i].discount =
                this.cartDiscounts[i].discount - Number(discount);
              return;
            }
          }
          break;
        case "remove":
          for (let i in this.cartDiscounts) {
            if (this.cartDiscounts[i].uuid === item.uuid) {
              this.cartDiscounts.splice(i, 1);
              return;
            }
          }
          break;
      }
    },
    updateProductsPlus: function(event) {
      for (let i in this.cart) {
        if (this.cart[i].uuid === event) {
          this.cart[i].quantity++;
          this.applyDiscount(this.cart[i], "increase");
          this.$events.fire("updatedCart", this.cart);
          return;
        }
      }
    },
    updateProductsMinus: function(event) {
      for (let i in this.cart) {
        if (this.cart[i].uuid === event) {
          if (this.cart[i].quantity === 1) {
            this.applyDiscount(this.cart[i], "decrease");
            this.cart.splice(i, 1);
            this.$events.fire("updatedCart", this.cart);
            return;
          }
          this.applyDiscount(this.cart[i], "decrease");
          this.cart[i].quantity--;
          this.$events.fire("updatedCart", this.cart);
          return;
        }
      }
    },
    setCartToCookie: function() {
      localStorage.setItem(
        "cart-" + this.company_slug,
        JSON.stringify(this.cart)
      );
      localStorage.setItem("discount-" + this.company_slug, this.discount);
    },
    notifyUser: function(type, item) {
      switch (type) {
        case "added_product":
          this.$vs.notify({
            group: "cart-actions",
            text: item.name + ' is toegevoegd aan je winkelwagen',
            type: "success"
          });
          this.$events.fire("updatedCart", this.cart);
          break;
      }
    },
    removeItem: function(event) {
      for (let i in this.cart) {
        if (this.cart[i].uuid === event) {
          this.applyDiscount(this.cart[i], "remove");
          this.cart.splice(i, 1);
          this.$events.fire("updatedCart", this.cart);
          return;
        }
      }
    }
  }
};
</script>
